import React from "react";
import Intercom from "@intercom/messenger-js-sdk";
import { useCentralStore } from "../store/Central";
import { getProfileDisplayName } from "@/lib/utils/client-utils";

export default function IntercomSnippet() {
	const { userId, userName, userEmail } = useCentralStore((state) => ({
		userId: state.userId,
		userName: getProfileDisplayName(state.profile),
		userEmail: state.userEmail,
	}));

	Intercom({
		app_id: import.meta.env.VITE_INTERCOM_APP_ID,
		user_id: userId ?? undefined,
		name: userName ?? undefined,
		email: userEmail ?? undefined,
		language_override: "de",
		using_app: "dentlab",
		hide_default_launcher: true,
	});

	return <></>;
}
